define('entities/phone/calls',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  /**
   * Backend-proxied recording stream. The raw 3CX RecordingUrl is protected by
   * an OAuth token and can't be loaded by the browser directly, so we point the
   * player/download at our own endpoint, which streams the audio authenticated
   * via tokenId. Pass download=true for an attachment instead of inline play.
   */
  App.reqres.setHandler('calls:record-stream-url', function (secId, download) {
    return Settings.url('compuzz2', 'v2/calls/' + secId + '/record', download ? { download: true } : undefined);
  });

  App.reqres.setHandler('calls:get-collection-url', function (params) {
    return Settings.url('compuzz2', 'v2/calls', params);
  });

  App.reqres.setHandler('calls:row-count-url', function (params) {
    return Settings.url('compuzz2', 'v2/calls/rowCount', params);
  });

  App.reqres.setHandler('calls:get-collection-url-phone-number', function (params) {
    return Settings.url('compuzz2', 'v2/calls/findByNumber', params);
  });

  App.reqres.setHandler('calls:row-count-url-phone-number', function (params) {
    return Settings.url('compuzz2', 'v2/calls/findByNumber/rowCount', params);
  });
});
